@if (sources.length) {
  <div class="sources-grid" @expand [@.disabled]="conversationType === 'results'">
    @for (source of displaySources; track source; let i = $index) {
      @if (i < 3) {
        <div
          class="source-tile numbered-tile"
          [attr.data-number]="i + 1"
          (click)="openSourceViewer(i)"
          >
          <div class="source-content">
            <div class="source-text">{{ source.preview }}</div>
          </div>
        </div>
      }
    }
    @if (hasMoreSources) {
      <div class="source-tile more-sources">
        <div class="more-sources-content">
          <mat-icon>more_horiz</mat-icon>
          <div class="more-sources-text">{{ moreSources.length }}+ more sources</div>
        </div>
        <div class="more-sources-list">
          @for (source of moreSources; track source; let i = $index) {
            <div
              class="more-source-item"
              [attr.data-number]="i + 4"
              (click)="openSourceViewer(i + 3)"
              >
              <span class="more-source-preview" [title]="source.fullPreview">{{ source.preview }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<!-- Source viewer sidebar -->
<app-source-viewer-sidebar
  [data]="sidebarData"
  [visible]="sidebarVisible"
  [conversationId]="conversationId"
  (closeSidebar)="closeSidebar()"
  >
</app-source-viewer-sidebar>
